import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { useLang } from "../../context/LanguageContext";
import { Button } from "../ui/button";
import { Building2, ArrowRight } from "lucide-react";

const INV_IMG = "https://images.pexels.com/photos/4940212/pexels-photo-4940212.jpeg";

export default function Investment() {
  const { t } = useLang();

  return (
    <section
      id="investment"
      data-testid="investment-section"
      className="relative py-24 md:py-32 bg-[#0A0A0A]"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center">
          <div className="lg:col-span-6">
            <div className="flex items-center gap-3 mb-6">
              <div className="gold-divider" />
              <span className="label-gold">{t("investment.label")}</span>
            </div>
            <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-semibold text-white leading-[1.1] tracking-tight mb-6">
              {t("investment.title")}
            </h2>
            <div className="space-y-5 text-neutral-300 leading-relaxed text-base lg:text-lg mb-10">
              <p>{t("investment.body1")}</p>
              <p>{t("investment.body2")}</p>
            </div>

            <div className="flex flex-wrap gap-6 mb-10 pb-10 border-b border-white/10">
              <div>
                <div className="font-display text-3xl font-bold text-[#F2B705]">Ciechocinek</div>
                <div className="text-xs text-neutral-500 tracking-widest uppercase mt-1">Planned location</div>
              </div>
              <div className="w-px bg-white/10 hidden sm:block" />
              <div>
                <div className="font-display text-3xl font-bold text-[#F2B705]">Warehouse · Cross-dock</div>
                <div className="text-xs text-neutral-500 tracking-widest uppercase mt-1">Scope</div>
              </div>
            </div>

            <Link to="/kontakt" data-testid="investment-cta">
              <Button
                variant="outline"
                className="border-[#F2B705]/50 text-[#F2B705] hover:bg-[#F2B705]/10 hover:text-[#F2B705] rounded-sm px-8 py-6 bg-transparent group"
              >
                <Building2 className="mr-2 w-4 h-4" strokeWidth={1.5} />
                {t("investment.cta")}
                <ArrowRight className="ml-2 w-4 h-4 group-hover:translate-x-1 transition-transform" />
              </Button>
            </Link>
          </div>

          <motion.div
            initial={{ opacity: 0, scale: 0.95 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            className="lg:col-span-6 relative"
          >
            <div className="relative aspect-[4/3] rounded-sm overflow-hidden border border-white/10">
              <img src={INV_IMG} alt="Logistics center" className="w-full h-full object-cover" />
              <div className="absolute inset-0 bg-gradient-to-t from-[#0A0A0A] via-[#0A0A0A]/20 to-transparent" />
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
